import clsx from "clsx";
import React from "react";
import "./settingsPageHeaderTitle.scss";

interface ISettingsPageHeaderTitleProps extends React.ComponentPropsWithoutRef<"h1"> { }

export const SettingsPageHeaderTitle = (props: ISettingsPageHeaderTitleProps) => {
    return <h1 {...props} className={clsx("settings-page-header-title", props.className)} />;
};
